<template>
    <div>
<!--      <router-link @click="todataSetMain" style="color: darkblue;float: left;padding-left: 5%;">-->
<!--        返回-->
<!--      </router-link>-->

      <div style="float: left">
      <el-button type="primary" size="medium" @click="todataSetMain"><i class="el-icon-arrow-left el-icon--left"></i>返回</el-button>
      </div>

      <div style="float: right">
        <el-button type="primary" size="medium" @click="tonewdefineDataSettest">下一步<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>

    <h1>定义数据源</h1>
      <div class="box">
          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-row>
              <el-col span="10" class="left">
                <el-form-item label="选择数据库" size="small">
                  <div style="width: 100%;height: 400px;border: #ebeef5 1px solid;overflow-y: scroll;text-align: left;padding-left: 5px;">
                    <div  v-for="(db,index) in dbList" :class="{active: index==isActive}"  @click="checkedItem(index, db.dbCode)" v-model="form.dbCode">{{db.dbCode}}</div>
                  </div>
                </el-form-item>
              </el-col>
              <el-col span="8" class="right">
                <el-form-item size="small" label="数据库id" prop="id" v-if="show">
                  <label slot="label">数据Id&emsp;</label>
                  <el-input type="text" v-model="form.id"></el-input>
                </el-form-item>
                <el-form-item size="small" label="时间" prop="createDate" v-if="show">
                  <label slot="label">数据库时间&emsp;</label>
                  <el-input type="text" v-model="form.createDate"></el-input>
                </el-form-item>
                <el-form-item size="small" label="数据库名字" prop="dbName" >
                  <label slot="label">数据库名字&emsp;</label>
                  <el-input type="text" v-model="form.dbName"></el-input>
                </el-form-item>
                    <el-form-item size="small" label="数据库编码" prop="dbCode">
                      <label slot="label">数据库编码&emsp;</label>
                      <el-input type="text" v-model="form.dbCode"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="链接字符串" prop="dbLink">
                      <label slot="label">链接字符串&emsp;</label>
                        <el-input type="text" v-model="form.dbLink"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="用户名" prop="dbUsername">
                      <label slot="label">&emsp;&emsp;用户名&emsp;</label>
                      <el-input type="text" v-model="form.dbUsername"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="密码" prop="dbPassword">
                      <label slot="label">&emsp;密码&emsp;</label>
                      <el-input type="text" v-model="form.dbPassword"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="驱动类" prop="dbDriver">
                      <label slot="label">&emsp;&emsp;驱动类&emsp;</label>
                      <el-input type="text" v-model="form.dbDriver" ></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="初始链接数量" prop="dbInitalLinkCounts">
<!--                      <el-input type="text" v-model="form.dbInitalLinkCounts"></el-input>-->
                      <el-input v-model="form.dbInitalLinkCounts" onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" maxlength="2" placeholder="长度最多为2并且只能是数字但是不能写0哟"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="最小链接数量" prop="dbMinimumLinkCounts">
<!--                      <el-input type="text" v-model="form.dbMinimumLinkCounts"></el-input>-->
                      <el-input v-model="form.dbMinimumLinkCounts" onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" maxlength="2" placeholder="长度最多为2并且只能是数字但是不能写0哟"></el-input>

                    </el-form-item>
                    <el-form-item size="small" label="最大链接数量" prop="dbMaximumLinkCounts">
<!--                      <el-input type="text" v-model="form.dbMaximumLinkCounts"></el-input>-->
                      <el-input v-model="form.dbMaximumLinkCounts" onkeyup="this.value=this.value.replace(/[^\d.]/g,'');" maxlength="2" placeholder="长度最多为2并且只能是数字但是不能写0哟"></el-input>

                    </el-form-item>
                    <el-form-item size="small" label="" prop="newdbCode">
                      <el-input type="hidden" v-model="form.newdbCode"></el-input>
                    </el-form-item>
                    <el-form-item size="small" label="" prop="dataSetId">
                      <el-input type="hidden" v-model="form.dataSetId"></el-input>
                    </el-form-item>
                    <el-col span="30">
                        <el-button type="primary" @click="reset">&emsp;重&emsp;置&emsp;</el-button>&emsp;&emsp;
                        <el-button type="primary" @click="testUrl">&emsp;测试链接&emsp;</el-button>&emsp;&emsp;
                        <el-button type="primary" @click="saveResource">保存到队列</el-button>
                    </el-col>`
                  </el-col>
              </el-row>
          </el-form>
      </div>
    </div>
</template>

<script>
    export default {
        name: "dataSourceMain",
        isActive: -1,
        state: -1,
        show: false,
        data(){
            return{
              dbList:[],
              form:{
                id: this.$route.params.id,
                dbName: this.$route.params.db_code,
                dbCode: this.$route.params.db_code,
                dbLink: this.$route.params.db_link,
                dbUsername: this.$route.params.db_username,
                dbPassword: this.$route.params.db_password,
                dbDriver: this.$route.params.db_driver,
                dbInitalLinkCounts: this.$route.params.db_inital_link_counts,
                dbMinimumLinkCounts: this.$route.params.db_minimum_link_counts,
                dbMaximumLinkCounts: this.$route.params.db_maximum_link_counts,
                createDate: this.$route.params.create_date,
                newdbCode :this.$route.params.db_code,
                dataSetId :this.$route.params.datasetId,
                t1DsId:this.$route.params.t1DsId,
              }
            }
      },
      mounted() {
          this.queryCodeList();
          console.log("上个页面传来的是",this.$route)
          let dbCode = this.$route.params.dbCode
          console.log("这时候",dbCode)
          if (dbCode == undefined){

          }else {
            this.checkedItem(this.isActive,dbCode)
          }
      },
      methods:{
          //点击下一步
        tonewdefineDataSettest(){


          this.$router.push({
            name:'newdefineDataSettest',
              query:{
              dataSetId:this.form.dataSetId,
               dbCode:this.form.dbCode,
              id:this.form.id
            }
          })
        },
          //点击返回
        todataSetMain(){
          this.$router.push({
            name:'dataSetMain',
            params:{
              datasetId:this.$route.params.datasetId
            }
          })
        },
        //选中重新加载页面信息
        checkedItem(index, code){
          this.isActive=index;
          console.log("选中的code是",code)
          var params = {code : code}
          this.$http.post("/dbManage/sys-datasource/queryDataSourceByCode", params).then(resp=>{
            this.form.id = resp.data[0].id;
            this.form.dbName = resp.data[0].db_name;
            this.form.dbCode = resp.data[0].db_code;
            this.form.dbDriver = resp.data[0].db_driver;
            this.form.dbLink = resp.data[0].db_link;
            this.form.dbInitalLinkCounts = resp.data[0].db_inital_link_counts;
            this.form.dbMinimumLinkCounts = resp.data[0].db_minimum_link_counts;
            this.form.dbMaximumLinkCounts = resp.data[0].db_maximum_link_counts;
            this.form.dbPassword = resp.data[0].db_password;
            this.form.dbUsername = resp.data[0].db_username;
            this.form.createDate = resp.data[0].create_date;
            this.form.newdbCode = resp.data[0].db_code;
            this.form.dataSetId = resp.data[0].dataSetId;
            console.log("选中时create_date",this.form.createDate)
          })

        },
        //重置
        reset(form){
          this.$refs['form'].resetFields();
        },
        //查询数据库编码
        queryCodeList(){
          this.$http.get("/dbManage/sys-datasource/queryCodeList").then(resp=>{
            this.dbList = resp.data;
            console.log("查询时",this.dbList[0].dbCode)
          })
        },
        //保存到队列
        saveResource(){
          if(this.form.dbDriver != "com.mysql.cj.jdbc.Driver"){
              this.$message.warning("请点击测试连接测试是否正确呢,暂时只支持mysql的哟")
            return ;
          }

          if(this.form.dbName == this.dbList.dbName){
            alert("数据库名字不能为空")
            return ;
          }
          if(this.form.dbCode == this.dbList.dbCode){
            alert("数据库编码不能为空")
            return ;
          }
          if(this.form.dbLink == this.dbList.dbLink){
            alert("链接字符串不能为空")
            return ;
          }
          if(this.form.dbUsername == this.dbList.dbUsername){
            alert("用户名不能为空")
            return ;
          }
          if(this.form.dbPassword == this.dbList.dbPassword){
            alert("密码不能为空")
            return ;
          }
          if(this.form.dbDriver == this.dbList.dbDriver){
            alert("驱动类不能为空")
            return ;
          }
          if(this.form.dbInitalLinkCounts == this.dbList.dbInitalLinkCounts){
            alert("初始链接数量不能为空")
            return ;
          }
          if(this.form.dbMinimumLinkCounts == this.dbList.dbMinimumLinkCounts){
            alert("最小链接数量不能为空")
            return ;
          }
          if(this.form.dbMaximumLinkCounts == this.dbList.dbMaximumLinkCounts){
            alert("最大链接数量不能为空")
            return ;
          }
          this.$confirm('确认保存到队列吗？', '',{
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(()=>{
            console.log("表单的值",this.form)
            this.$http.post("/dbManage/sys-datasource/saveDataSource",this.form).then(resp=>{
              this.$message({type:'info', message:'保存到成功'});
              this.$router.go(0)
            })
          }).catch(action=>{
            this.$message({type:'info', message: action === 'cancle' ? '取消保存' : '取消操作'})
          })
        },
        //测试连接
        testUrl(){
          this.$http.post("/dbManage/sys-datasource/testURL",this.form).then(resp=>{
            if (resp.data == '连接成功！') {
              this.$alert('连接成功！','',{distinguishCancelAndClose: true})
            } else {
              this.$alert('连接失败！','',{distinguishCancelAndClose: true})
            }
          })
        },
        }
      }
</script>

<style scoped>
  .right{
    margin-left: 10%;
  }
  .left{
    padding-left: 10%;
  }
  .box{
    padding-top: 2%;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataSource/dataSourceMain.vue